import { render, staticRenderFns } from "./messageCenterModal.vue?vue&type=template&id=50dd9674&scoped=true&"
import script from "./messageCenterModal.vue?vue&type=script&lang=js&"
export * from "./messageCenterModal.vue?vue&type=script&lang=js&"
import style0 from "./messageCenterModal.vue?vue&type=style&index=0&id=50dd9674&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dd9674",
  null
  
)

export default component.exports